<template>
    <div
        class="tw:w-full tw:flex tw:flex-col TABS"
        id="api-inline-booking-wizard"
    >
        <div class="tw:flex tw:justify-end tw:mb-2">
            <button
                type="button"
                @click.stop="close()"
                aria-label="Close"
                class="tw:inline-flex tw:items-center tw:justify-center tw:h-8 tw:w-8 tw:rounded-full tw:bg-gray-200 hover:tw:bg-gray-300 tw:text-gray-600 hover:tw:text-gray-800 tw:transition-colors tw:duration-150 tw:shadow-sm focus:tw:outline-none focus:tw:ring-2 focus:tw:ring-primary-500 focus:tw:ring-offset-1"
            >
                <span :class="{'tw:text-xl tw:leading-none': wizardStore.tw}">&times;</span>
            </button>
        </div>
        <LoadingSpinner :isLoading="isLoadingWizardData" :tw="true" />
        <div v-if="webShopState.isOptima && wizardData">
            <bookingwizard
                :tw="true"
                :packageId="wizardData.packageId"
                :courseId="wizardData.courseId"
                :classId="wizardData.classId"
                :followUpId="wizardData.followUpId"
                :freeSlots="wizardData.freeSlots"
                :freeInterpreterSlots="wizardData.freeInterpreterSlots"
                :productId="wizardData.productId"
                :productType="productTypeId"
                :isDeliverable="wizardData.isDeliverable"
                :officeId="wizardData.officeId"
                :nnidPlaceholder="webShopState.nnidPlaceholder"
                :yskLocationId="wizardData.yskLocationId"
                :hasSwish="wizardData.hasSwish"
                :hasNets="wizardData.hasNets"
                :officeName="wizardData.officeName"
                :brandingDomain="wizardData.brandingDomain"
                :studentPageName="wizardData.studentPageName"
                :eventStartTime="wizardData.eventStartTime"
            />
            <div v-if="wizardStore.bookingTerms" class="tw:mt-4 tw:text-xs tw:text-zinc-600 tw:px-4" v-html="wizardStore.bookingTerms"></div>
        </div>
        <div v-if="!webShopState.isOptima && wizardData">
            <div v-html="wizardData"></div>
        </div>
        <div v-if="loadingError" class="tw:border tw:border-red-800 tw:bg-red-50 tw:text-red-800 tw:p-4 tw:rounded-md tw:mt-4">
            {{ $t('Det oppstod en feil under lasting av bestillingsveiviseren. Vennligst prøv igjen senere.') }}
        </div>
    </div>
</template>

<script setup>

import {computed, ref, onMounted} from 'vue'
import ProductTypes from "../../../productTypes";
import Bookingwizard from "../optima/BookingWizard.vue";
import LoadingSpinner from '../optima/wizard/loadingSpinner.vue';
import { useWebShopStore } from "./webshopState";
import { useWizardStore } from "../optima/wizard/wizardState.js";
import axios from 'axios';
const webShopState = useWebShopStore();
const wizardStore = useWizardStore();
const isLoadingWizardData = ref(false);

const product = computed(() => webShopState.selectedProduct)
const course = computed(() => webShopState.selectedCourse)

const isPackage = computed(() => product.value.typeId === ProductTypes.PAKKE)
const productTypeId = computed(() => product.value.typeId)
const isCourse = computed(() => !!course.value)
const officeId = computed(() => isCourse.value ? course.value.officeId : product.value.officeId)
const packageId = computed(() => isPackage.value ? product.value.productId : null)
const classId = computed(() => product.value.classId)
const format = computed(() => webShopState.isOptima ? 'json': 'html')
const loadingError = ref(false)

const wizardData = ref(null)

const close = () => {
    webShopState.closeProduct();
}

const getWizardData = async () => {
    // Simulate an API call
    loadingError.value = false;
    const endpoint = window.TABS.api.getEndPoint("booking", 'v2', officeId.value, format.value);
    isLoadingWizardData.value = true;
    const requestData = {
        productType: productTypeId.value,
        packageId: packageId.value,
        classId: classId.value,
        courseId: course.value ? course.value.course_id : null,
        productId: product.value.productId,
        inline: true,
    }
    try {
        const { data, status } = await axios.get(endpoint, {
            withCredentials: true,
            params: requestData,
        });
        isLoadingWizardData.value = false;
        if (status < 200 || status >= 300) throw new Error(`HTTP ${status}`);
        return data;
    } catch (err) {
        isLoadingWizardData.value = false;
        loadingError.value = true;
        console.error("Failed to load shop data", err);
        return null;
    }
}

onMounted(async () => {
    setTimeout(()=> {
        document.getElementById('api-inline-booking-wizard').scrollIntoView({block:'center'})
    }, 500)

    wizardData.value = await getWizardData()
})
</script>
